import { makeStyles } from "@material-ui/core/styles";
import { fontWeight, padding } from "@mui/system";

export default makeStyles({
  navbar: {
    height: 70,
    background: "#fefff0",
    display: "flex",
    paddingLeft: 30,
    paddingRight: 30,
    justifyContent: "space-between",
    color: "#547972",
    alignItems: "center",
    ["@media (max-width:750px)"]: {
      paddingRight: 10,
    },
  },
  options: {
    display: "flex",
    alignContent: "center",
    justifyContent: " center",
    ["@media (max-width:750px)"]: {
      display: "none",
    },
  },
  links: {
    color: "#547972",
    // color: "#fefff0",
    fontSize: 20,
    textDecoration: "none",
    padding: 24,
    zIndex: -1,

    "&:hover": {
      background: "#547972",
      color: "#fefff0",
    },
  },
  box: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#fefff0",
    paddingTop: 20,
  },
  list: {
    display: "flex",
    height: 70,
    alignItems: "center",
  },
  togglelinks: {
    width: "100%",
    padding: 24,
    color: "#547972",
    fontSize: 20,
    textDecoration: "none",
    "&:hover": {
      background: "#547972",
      color: "#fefff0",
    },
  },
  drawer: {
    ["@media (min-width:751px)"]: {
      display: "none",
    },
  },
});
